var map = {
	"./dashboard.svg": 7060,
	"./example.svg": 1649,
	"./eye-open.svg": 2429,
	"./eye.svg": 5628,
	"./form.svg": 3771,
	"./link.svg": 1445,
	"./nested.svg": 5016,
	"./password.svg": 9902,
	"./table.svg": 4383,
	"./tree.svg": 2701,
	"./user.svg": 8848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;